(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["andersen-faq-hub"] && !Shopify.designMode) return;
  try {
    
  if (!customElements.get('andersen-faq-hub')) {
    class AndersenFaqHub extends HTMLElement {
      connectedCallback() {
        this.form = this.querySelector('[data-faq-hub-search-form]');
        this.input = this.querySelector('[data-faq-hub-search]');
        this.clearButton = this.querySelector('[data-faq-hub-clear]');
        this.resultsSection = this.querySelector('[data-faq-hub-results-section]');
        this.results = this.querySelector('[data-faq-hub-results]');
        this.status = this.querySelector('[data-faq-hub-status]');
        this.sources = Array.from(this.querySelectorAll('[data-faq-source]'));
        this.questionIndex = [];
        this.loadPromise = null;
        this.form.addEventListener('submit', (event) => {
          event.preventDefault();
          this.runSearch();
        });
        this.input.addEventListener('input', () => this.runSearch());
        this.input.addEventListener('focus', () => this.loadQuestions());
        this.clearButton.addEventListener('click', () => {
          this.input.value = '';
          this.clearResults();
          this.input.focus();
        });
      }

      normalize(value) {
        return value.toLowerCase().replace(/[^a-z0-9]+/g, ' ').trim();
      }

      loadQuestions() {
        if (this.loadPromise) return this.loadPromise;
        this.loadPromise = Promise.all(this.sources.map(async (source) => {
          try {
            const response = await fetch(source.href, { credentials: 'same-origin' });
            if (!response.ok) return [];
            const html = await response.text();
            const documentFragment = new DOMParser().parseFromString(html, 'text/html');
            return Array.from(documentFragment.querySelectorAll('[data-faq-item]')).map((item) => {
              const question = item.querySelector('summary')?.textContent.trim() || '';
              const answer = item.querySelector('[data-faq-answer]')?.textContent.trim() || '';
              return {
                question,
                answer,
                category: source.dataset.categoryTitle,
                href: `${new URL(source.href, window.location.origin).pathname}#${item.id}`
              };
            }).filter((entry) => entry.question);
          } catch (error) {
            return [];
          }
        })).then((groups) => {
          this.questionIndex = groups.flat();
          return this.questionIndex;
        });
        return this.loadPromise;
      }

      async runSearch() {
        const query = this.normalize(this.input.value);
        this.clearButton.hidden = query.length === 0;
        if (query.length < 2) {
          this.clearResults();
          return;
        }
        this.resultsSection.hidden = false;
        this.status.textContent = 'Searching…';
        await this.loadQuestions();
        const terms = query.split(' ');
        const matches = this.questionIndex.filter((entry) => {
          const haystack = this.normalize(`${entry.question} ${entry.answer} ${entry.category}`);
          return terms.every((term) => haystack.includes(term));
        }).slice(0, 20);
        this.renderResults(matches);
      }

      renderResults(matches) {
        this.results.replaceChildren();
        if (!matches.length) {
          const item = document.createElement('li');
          item.textContent = 'No matching questions found. Try a product name, part, symptom, or setup term.';
          this.results.append(item);
          this.status.textContent = '0 results';
          return;
        }
        matches.forEach((match) => {
          const item = document.createElement('li');
          const link = document.createElement('a');
          const question = document.createElement('span');
          const category = document.createElement('span');
          link.className = 'faq-hub__result-link';
          link.href = match.href;
          question.className = 'faq-hub__result-question';
          category.className = 'faq-hub__result-category';
          question.textContent = match.question;
          category.textContent = match.category;
          link.append(question, category);
          item.append(link);
          this.results.append(item);
        });
        this.status.textContent = `${matches.length} result${matches.length === 1 ? '' : 's'}`;
      }

      clearResults() {
        this.resultsSection.hidden = true;
        this.results.replaceChildren();
        this.status.textContent = '';
      }
    }
    customElements.define('andersen-faq-hub', AndersenFaqHub);
  }

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["andersen-faq-page"] && !Shopify.designMode) return;
  try {
    
  if (!customElements.get('andersen-faq-page')) {
    class AndersenFaqPage extends HTMLElement {
      connectedCallback() {
        this.input = this.querySelector('[data-faq-search]');
        this.form = this.querySelector('[data-faq-search-form]');
        this.clearButton = this.querySelector('[data-faq-clear]');
        this.emptyClearButton = this.querySelector('[data-faq-empty-clear]');
        this.status = this.querySelector('[data-faq-status]');
        this.emptyState = this.querySelector('[data-faq-empty]');
        this.items = Array.from(this.querySelectorAll('[data-faq-item]'));
        this.headings = Array.from(this.querySelectorAll('[data-topic-heading]'));
        this.filterButtons = Array.from(this.querySelectorAll('[data-topic-filter]'));
        this.activeTopic = 'all';
        this.form.addEventListener('submit', (event) => event.preventDefault());
        this.input.addEventListener('input', () => this.update());
        this.clearButton.addEventListener('click', () => this.clearSearch());
        this.emptyClearButton.addEventListener('click', () => this.clearSearch());
        this.filterButtons.forEach((button) => button.addEventListener('click', () => this.selectTopic(button)));
        this.querySelector('[data-faq-expand]').addEventListener('click', () => this.setAll(true));
        this.querySelector('[data-faq-collapse]').addEventListener('click', () => this.setAll(false));
        window.addEventListener('hashchange', () => this.openHashTarget());
        this.openHashTarget();
      }

      normalize(value) {
        return value.toLowerCase().replace(/[^a-z0-9]+/g, ' ').trim();
      }

      update() {
        const query = this.normalize(this.input.value);
        const terms = query ? query.split(' ') : [];
        let visibleCount = 0;
        this.clearButton.hidden = query.length === 0;
        this.items.forEach((item) => {
          const topicMatch = this.activeTopic === 'all' || item.dataset.topic === this.activeTopic;
          const haystack = this.normalize(item.textContent);
          const searchMatch = terms.every((term) => haystack.includes(term));
          const visible = topicMatch && searchMatch;
          item.hidden = !visible;
          if (visible) visibleCount += 1;
        });
        this.headings.forEach((heading) => {
          heading.hidden = !this.items.some((item) => !item.hidden && item.dataset.topic === heading.dataset.topicHeading);
        });
        this.emptyState.hidden = visibleCount !== 0;
        this.status.textContent = `${visibleCount} question${visibleCount === 1 ? '' : 's'} shown`;
      }

      selectTopic(button) {
        this.activeTopic = button.dataset.topicFilter;
        this.filterButtons.forEach((candidate) => {
          const active = candidate === button;
          candidate.classList.toggle('is-active', active);
          candidate.setAttribute('aria-pressed', active ? 'true' : 'false');
        });
        this.update();
      }

      clearSearch() {
        this.input.value = '';
        this.clearButton.hidden = true;
        this.update();
        this.input.focus();
      }

      setAll(open) {
        this.items.filter((item) => !item.hidden).forEach((item) => {
          item.open = open;
        });
        this.status.textContent = open ? 'Visible answers expanded' : 'Visible answers collapsed';
      }

      openHashTarget() {
        if (!window.location.hash) return;
        const target = this.querySelector(window.location.hash);
        if (!target || !target.matches('[data-faq-item]')) return;
        target.open = true;
        requestAnimationFrame(() => target.scrollIntoView({ block: 'start' }));
      }
    }
    customElements.define('andersen-faq-page', AndersenFaqPage);
  }

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["main-cart-footer"]) return;
  try {
    
  class CartNote extends HTMLElement {
    constructor() {
      super();

      this.addEventListener(
        'change',
        debounce((event) => {
          const body = JSON.stringify({ note: event.target.value });
          fetch(`${routes.cart_update_url}`, { ...fetchConfig(), ...{ body } });
        }, 300),
      );
    }
  }
  customElements.define('cart-note', CartNote);

  } catch(e) { console.error(e); }
})();
})();
